import { useQueryClient } from "react-query";
import { CircularProgress } from "@mui/material";

import PrimaryButton from "../../../Components/Buttons/primary-button";

import renderVerifyToViewVirtualCard from "./verify-to-view-virtual-card";
import renderStatusModal from "../status-modal";

import { useStakeDebit } from "../../../CustomHooks/Queries";
import { useRequestVirtualStakeDebit } from "../../../CustomHooks/Mutations";

import { useModalContext } from "../../../Contexts/ModalContext";

import { dispatchAPIErrorToast } from "../../../Utils/helpers";
import { APIQueryKeys, modalVariants } from "../../../Utils/constants";

import { CheckCircleWithShadow } from "../../../Assets/Icons";
import { StakeCardFrontSide } from "../../../Assets/Images";
import ModalSkeleton from "../../../Components/Skeleton/modal-skeleton";
import { useEffect } from "react";

const SuccessfullyRequestedVirtualCardStatusModalProps = {
  StatusIcon: CheckCircleWithShadow,
  title: "Activation success!",
  description: "Your virtual debit card is now available for use",
  CTAButtonText: "View virtual debit card",
};

export default function renderRequestVirtualCard(modalContext) {
  const { updateModalComponent, setModalVariant, setModalTitle, setModalClassName } = modalContext;

  updateModalComponent(RequestVirtualCard);
  setModalTitle("Manage Virtual Card");
  setModalVariant(modalVariants.formDialog);
  setModalClassName("hide-header");
}

const RequestVirtualCard = () => {
  const modalContext = useModalContext();
  const { setModalClassName, popModalStack } = modalContext;

  const queryClient = useQueryClient();

  const { isLoading: isLoadingStakeDebit, data: stakeDebit } = useStakeDebit();

  const { isLoading: isRequestingVirtualDebit, mutate: RequestStakeVirtualDebit } = useRequestVirtualStakeDebit({
    onSuccess: () => {
      queryClient.refetchQueries(APIQueryKeys.stakeDebit);
      renderStatusModal(modalContext, {
        ...SuccessfullyRequestedVirtualCardStatusModalProps,
        onCTAButtonClick: renderVerifyToViewVirtualCard.bind(this, modalContext),
      });
    },
    onError: () => dispatchAPIErrorToast(),
  });

  const isSyncteraUser = stakeDebit?.data?.data?.is_synctera_user;

  useEffect(() => {
    setModalClassName(isSyncteraUser ? "hide-header" : "");
  }, [isSyncteraUser, setModalClassName]);

  return isLoadingStakeDebit ? (
    <ModalSkeleton className="mt-6" />
  ) : (
    <>
      <div className="modal-dialog-content">
        <div className={`${isSyncteraUser ? "coming-soon my-6" : ""}`} alt="">
          <img className="stake-card-front-side" src={StakeCardFrontSide} alt="" />
        </div>
        {isSyncteraUser && (
          <>
            <h3 className="modal-status-title mb-2">Debit cards will be available soon</h3>
            <div className="modal-content-text">
              Your checking account is active. Physical and virtual cards will be issued at a later date, and we’ll
              notify you once your Stake Debit card is available.
            </div>
          </>
        )}
      </div>
      <div className="action-container">
        {isSyncteraUser ? (
          <PrimaryButton onClick={() => popModalStack(1)}>Got It</PrimaryButton>
        ) : (
          <PrimaryButton onClick={RequestStakeVirtualDebit} disabled={isRequestingVirtualDebit}>
            Activate Card {isRequestingVirtualDebit && <CircularProgress />}
          </PrimaryButton>
        )}
      </div>
    </>
  );
};
